import { useState } from 'react'

import { Role } from 'Attendances/types'
import getRoleOnCustomForm from './services/getRoleOnCustomForm'

export default function useGetRoleByID() {
  const [loadingRole, setLoadingRole] = useState<boolean>(false)
  const [role, setRole] = useState<Role>({})

  async function getRole(roleId?: string) {
    setLoadingRole(true)
    const response = await getRoleOnCustomForm({ roleId: roleId as string })
    let roleFromAPI: Role = {}
    if (response?.header?.success) {
      roleFromAPI = response?.body?.role
      setRole(roleFromAPI)
    }
    setLoadingRole(false)
    return roleFromAPI
  }

  return { getRole, role, loadingRole }
}
